export const LOCALE = 'en_AU';
export const DEBOUNCE_TIME = 300;
export const DATETIME_DISPLAY_FORMAT = 'DD-MM-YYYY HH:mm';
export const POLL_REPORT_BRAND_COLOR = '#7f4d93';
